import { defineStore } from 'pinia';

type TTimestampTTL = number;

interface IStorage {
  hasSeenBonusPopUp: TTimestampTTL;
}

type TTtlStoreKey = keyof IStorage;

export const ttlKeys: { [k in TTtlStoreKey]: TTtlStoreKey } = {
  hasSeenBonusPopUp: 'hasSeenBonusPopUp',
} as const;

/**
 * Стор для хранения значений на определенный период времени
 */
export const useTtlStorage = defineStore('ttlStorage', {
  state() {
    const stateData: IStorage = {
      hasSeenBonusPopUp: 0,
    };
    return stateData;
  },

  getters: {
    // Проверяет, активен ли сейчас ключ
    isAvailable(state) {
      return (key: TTtlStoreKey): boolean => {
        const ttl = state[key];

        if (ttl <= 0) {
          return true;
        }
        const now = Date.now();
        return now > ttl;
      };
    },
  },

  actions: {
    setExpireTime(key: TTtlStoreKey, date: Date | TTimestampTTL) {
      const time = date instanceof Date ? date.getTime() : date;

      this[key] = time;
    },
  },

  // Включаем сохранение стейта в localStorage
  persist: typeof window !== 'undefined',
});
